import React from "react";

interface HeadingAndSubHeadingProps {
  heading: string;
  subHeading?: string;
  className?: string;
  cityName?: string; // Optional city name for dynamic heading
}

const HeadingAndSubHeading: React.FC<HeadingAndSubHeadingProps> = ({
  heading,
  subHeading,
  className = "",
  cityName,
}) => {
  // Determine the favourites text based on city selection
  // If cityName is provided and truthy, use dynamic city-based text
  // Otherwise, use subHeading if provided, or fallback to "India's favourites"
  const favouritesText = cityName ? `${cityName}'s favourites` : "India's favourites";
  
  // If cityName prop was passed (even if undefined), prioritize dynamic text
  // Otherwise, use subHeading if provided
  const displaySubHeading = cityName !== undefined 
    ? favouritesText 
    : (subHeading || favouritesText);
  
  return (
    <div className={className}>
      <h3 className="text-[12px] md:text-[16px] font-medium text-gray-700">
        {heading || "RENTALS HANDPICKED FOR YOU"}
      </h3>
      <h2 className="text-[20px] md:text-[32px] font-medium text-black mb-4">
        {displaySubHeading}
      </h2>
    </div>
  );
};

export default HeadingAndSubHeading;
